import { createFileRoute, notFound } from "@tanstack/react-router";

import { getArticle, getCoverUrl } from "@/lib/articles";
import { ArticlePageContent } from "../../news/$id";

export const Route = createFileRoute("/en/news/$id")({
	loader: async ({ params }) => {
		const article = await getArticle(params.id, "en");
		if (!article) throw notFound();
		return { article };
	},
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=14400, stale-while-revalidate=86400",
	}),
	head: ({ loaderData }) => {
		const { article } = loaderData ?? {};
		if (!article) return {};
		const title = article.title;
		const description = article.excerpt;
		const coverUrl = getCoverUrl(article);
		const imageUrl =
			coverUrl ?? "https://makedonijaturist.com.mk/makedonijaturist.png";

		return {
			meta: [
				{ title: `${title} | Makedonijaturist AD` },
				{ name: "description", content: description },
				{ property: "og:title", content: title },
				{ property: "og:description", content: description },
				{ property: "og:image", content: imageUrl },
				{ property: "og:type", content: "article" },
				{ name: "twitter:card", content: "summary_large_image" },
				{ name: "twitter:title", content: title },
				{ name: "twitter:description", content: description },
				{ name: "twitter:image", content: imageUrl },
			],
			links: [
				{
					rel: "canonical",
					href: `https://makedonijaturist.com.mk/en/news/${article.documentId}`,
				},
			],
			scripts: [
				{
					type: "application/ld+json",
					children: JSON.stringify({
						"@context": "https://schema.org",
						"@type": "NewsArticle",
						headline: title,
						description: description,
						image: imageUrl,
						datePublished: article.date,
						publisher: {
							"@type": "Organization",
							name: "Makedonijaturist AD",
							logo: {
								"@type": "ImageObject",
								url: "https://makedonijaturist.com.mk/logo512.png",
							},
						},
					}),
				},
			],
		};
	},
	component: EnArticlePage,
});

function EnArticlePage() {
	const { article } = Route.useLoaderData();
	return <ArticlePageContent article={article} />;
}
